"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyManagementMenuCard = void 0;
const client_shared_1 = require("@teams/client-shared");
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const __1 = require("../..");
const commands_2 = require("../commands");
const surveyManagementMenuCard = (survey, isUserOwner, hasUserResponded, allowEdit) => {
    const card = CardHelper_1.CardHelper.newCard();
    const displayType = (0, CardHelper_1.getSurveyTypeDisplay)(survey.type);
    const canEditResponses = survey.state === "open" && survey.type === "survey" && hasUserResponded;
    if (canEditResponses) {
        card.addItem(menuItemNoConfirm("Edit Reponses", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            data: (0, commands_1.takingStartCommand)(survey.id, true).toTaskFetchCommand(),
            title: "Edit Responses",
        })));
    }
    if (!isUserOwner) {
        return card;
    }
    if (allowEdit) {
        if (survey.state === "open") {
            card.addItem(menuItemNoConfirm("Edit polly", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                data: (0, commands_2.SurveyEditCommand)(survey.id).toTaskFetchCommand(),
                title: "Edit",
            })));
        }
    }
    if (survey.state !== "closed" && (0, client_shared_1.canCreateWebShareForPolly)(survey.type)) {
        card.addItem(menuItemNoConfirm("Share web voting link", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            data: (0, commands_2.SurveyWebShareCommand)(survey.id).toTaskFetchCommand(),
            title: "Share",
        })));
    }
    if (allowEdit) {
        card.addItem(menuItemNoConfirm("Duplicate Polly", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Duplicate",
            data: (0, commands_2.SurveyDuplicateAuthoringCommand)(survey.id).toTaskFetchCommand(),
        })));
    }
    if (!survey.scheduleId) {
        card.addItem(menuItemNoConfirm("Export to CSV", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            data: (0, commands_2.SurveyResultsExportCommand)(survey.id),
            title: "Export",
        })));
    }
    if (survey.state === "open") {
        card.addItem(menuItem("Close", displayType, (0, __1.SurveyCloseCommand)(survey.id)));
    }
    if (allowEdit) {
        if (survey.state === "closed" && survey.type !== "trivia") {
            card.addItem(menuItemNoConfirm("Reopen polly", CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                data: (0, commands_2.SurveyReopenCommand)(survey.id).toTaskFetchCommand(),
                title: "Reopen",
            })));
        }
    }
    if (!survey.scheduleId) {
        card.addItem(menuItem("Delete", displayType, (0, commands_2.SurveyDeleteCommand)(survey.id)));
    }
    else {
        card.addItem(menuItem("Delete", "instance", (0, commands_2.SurveyDeleteCommand)(survey.id)));
        card.addItem(menuItem("Delete", "series", (0, commands_1.scheduleDeleteCommand)({ scheduleId: survey.scheduleId })));
    }
    return card;
};
exports.surveyManagementMenuCard = surveyManagementMenuCard;
function menuItemNoConfirm(title, action) {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        separator: true,
    });
    const columns = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet);
    const leftCol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
        width: "stretch",
    });
    const titleText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: title,
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
    });
    leftCol.addItem(titleText);
    const rightCol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { width: "auto" });
    const actionSet = CardHelper_1.CardHelper.create(adaptivecards_1.ActionSet, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
    });
    actionSet.addAction(action);
    rightCol.addItem(actionSet);
    columns.addColumn(leftCol);
    columns.addColumn(rightCol);
    container.addItem(columns);
    return container;
}
function menuItem(title, typeDisplay, confirmCommand) {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        separator: true,
    });
    const columns = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet);
    const leftCol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
        width: "stretch",
    });
    const titleText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${title} ${typeDisplay}`,
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
    });
    leftCol.addItem(titleText);
    const rightCol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { width: "auto" });
    const actionSet = CardHelper_1.CardHelper.create(adaptivecards_1.ActionSet, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
    });
    const toggleAction = CardHelper_1.CardHelper.create(adaptivecards_1.ToggleVisibilityAction, {
        title,
    });
    toggleAction.addTargetElement(`${title}_${typeDisplay}_confirm`);
    actionSet.addAction(toggleAction);
    rightCol.addItem(actionSet);
    columns.addColumn(leftCol);
    columns.addColumn(rightCol);
    container.addItem(columns);
    const confirmContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        id: `${title}_${typeDisplay}_confirm`,
        isVisible: false,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    confirmContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `⚠️ Are you sure you want to ${title.toLocaleLowerCase()} this ${typeDisplay}?`,
        wrap: true,
        spacing: adaptivecards_1.Spacing.Large,
    }));
    const confirmActionSet = new adaptivecards_1.ActionSet();
    confirmActionSet.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: `Confirm ${title}`,
        data: confirmCommand.toTaskFetchCommand(),
    }));
    confirmContainer.addItem(confirmActionSet);
    container.addItem(confirmContainer);
    return container;
}
//# sourceMappingURL=SurveyManagementMenu.js.map